import { createContext } from 'react';

export interface IDeltaUIContext {
  showMoreDetails: boolean;
  setShowMoreDetails: (value: boolean) => void;
  showOnlyUpdatedParagraphs: boolean;
  handleShowOnlyChangedParagraphs: (value: boolean) => void;
  shouldBeRefresh: boolean;
  setShouldBeRefresh: (value: boolean) => void;
}

const DeltaUIContext = createContext<IDeltaUIContext | undefined>(undefined);

export default DeltaUIContext;
